import numeral from "numeral"

interface Options {
  format?: string
  currency?: string
}

function formatNumber(
  value: number | string | undefined | null,
  options?: Options
): string {
  const { format = "(0,0a)", currency = "$" } = options || {}

  const num = typeof value === "string" ? parseFloat(value) : value

  if (num === undefined || num === null || isNaN(num)) return ""

  return currency + numeral(num).format(format)
}

export { formatNumber }
